export const easyWords = [
  "cat", "dog", "sun", "run", "fly", "sky", "red", "big", "tea", "joy",
  "map", "key", "ice", "bus", "car", "cup", "bag", "egg", "fox", "owl",
  "pen", "rain", "tree", "fish", "moon", "star", "book", "song", "wind",
  "fire", "love", "play", "blue", "rose", "hope", "snow", "kite", "lion",
  "duck", "cake", "milk", "leaf", "lake", "bird", "frog", "bear", "wolf",
  "ant", "bee", "ape", "ant", "arm", "axe", "ash", "ate", "age", "air",
  "bat", "bay", "bed", "boy", "box", "bow", "bun", "bud", "bug", "bus",
  "cap", "cab", "cow", "cry", "cut", "den", "dig", "dip", "dot", "dry",
  "ear", "eat", "elf", "eye", "end", "fan", "far", "fat", "few", "fig",
  "fit", "fix", "fog", "fun", "gap", "gas", "get", "god", "gym", "ham",
  "hat", "hen", "hop", "hot", "hut", "ink", "jet", "jog", "jug", "kid",
  "lap", "law", "lay", "leg", "lid", "lip", "log", "mad", "mat", "men",
  "mix", "mom", "mop", "mud", "mug", "nap", "net", "new", "nod", "now",
  "nut", "oak", "odd", "oil", "old", "one", "out", "pan", "pat", "paw",
  "pet", "pie", "pig", "pin", "pit", "pop", "pot", "pup", "ram", "rat",
  "raw", "rib", "rim", "rip", "rob", "rod", "rug", "run", "sad", "saw",
  "sea", "set", "sip", "sir", "sit", "six", "ski", "sky", "sob", "son",
  "soup", "spy", "tap", "tax", "ten", "tie", "tin", "tip", "toe", "ton",
  "top", "toy", "tub", "two", "use", "van", "vet", "war", "wax", "way",
  "web", "wet", "who", "why", "wig", "win", "yes", "yet", "zip", "zoo",
];

export const mediumWords = [
  "computer", "internet", "music", "monkey", "garden", "rocket", "planet",
  "winter", "summer", "forest", "castle", "bridge", "purple", "yellow",
  "orange", "guitar", "window", "circle", "dragon", "silver", "golden",
  "memory", "thunder", "diamond", "shadow", "crystal", "jungle", "wonder",
  "harbor", "marble", "velvet", "mirror", "puzzle", "candle", "wizard",
  "animal", "bottle", "branch", "button", "camera", "cinema", "coffee",
  "cookie", "cotton", "danger", "desert", "dinner", "doctor", "dollar",
  "engine", "family", "father", "finger", "flower", "friend", "future",
  "gentle", "ginger", "ground", "hammer", "honest", "island", "junior",
  "kitten", "ladder", "lemon", "letter", "lizard", "magnet", "market",
  "modern", "morning", "mother", "muscle", "narrow", "nature", "nephew",
  "object", "office", "orange", "parent", "pencil", "people", "person",
  "pillow", "pirate", "planet", "pocket", "poison", "potato", "powder",
  "prince", "rabbit", "rocket", "rubber", "saddle", "salmon", "school",
  "silver", "simple", "singer", "sister", "smooth", "social", "spider",
  "spring", "square", "stream", "string", "stripe", "studio", "subway",
  "summer", "tablet", "talent", "temple", "tennis", "ticket", "tiger",
  "tomato", "travel", "turkey", "turtle", "uncle", "valley", "violet",
  "voyage", "walnut", "wallet", "weapon", "weasel", "weight", "winter",
];

export const hardWords = [
  "globalization", "magnificent", "brainstorm", "pronunciation",
  "extraordinary", "imagination", "incredible", "perception", "revolution",
  "atmosphere", "philosophy", "engineering", "literature", "perspective",
  "consequence", "understand", "experience", "appreciate", "communicate",
  "celebration", "navigation", "foundation", "discovery", "expression",
  "phenomenon", "ridiculous", "spectacular", "tremendous", "remarkable",
  "achievement", "adventurous", "ambassador", "anniversary", "appearance",
  "approximate", "architecture", "arithmetic", "atmosphere", "background",
  "battleship", "boundaries", "calculation", "carbohydrate", "carnivorous",
  "catastrophe", "championship", "characteristic", "circumstance", "civilization",
  "combination", "commercial", "compassion", "complicated", "concentration",
  "condition", "configuration", "conjunction", "consciousness", "conservation",
  "consideration", "constitution", "construction", "consultation", "contemporary",
  "controversy", "convenience", "cooperation", "corporation", "correspondence",
  "criticism", "curriculum", "declaration", "definition", "demonstration",
  "department", "description", "destination", "determination", "development",
  "difference", "difficulty", "disappointment", "discrimination", "distribution",
  "diversity", "documentary", "domestic", "economic", "education",
  "efficiency", "electricity", "embarrassment", "emergency", "employment",
  "encyclopedia", "enterprise", "environment", "equipment", "establishment",
  "evaluation", "evolution", "examination", "exhibition", "explanation",
  "extension", "fascinating", "fluorescent", "frequency", "frustration",
];

export const expertWords = [
  "serendipity", "quintessential", "idiosyncratic", "exacerbate",
  "perspicacious", "obfuscation", "magnanimous", "surreptitious",
  "vicissitude", "ephemeral", "ubiquitous", "cacophony", "perfunctory",
  "incontrovertible", "discombobulate", "antediluvian", "supercilious",
  "perspicuity", "recalcitrant", "circumlocution", "pulchritudinous",
  "sesquipedalian", "anachronistic", "preposterous", "indefatigable",
  "acquiesce", "alacrity", "ameliorate", "anachronism", "antithesis",
  "apocryphal", "approbation", "approbatory", "ascertain", "askance",
  "assiduous", "astringent", "audacious", "bellicose", "bombastic",
  "byzantine", "cantankerous", "capricious", "castigate", "censorious",
  "circumspect", "clandestine", "cognoscenti", "commensurate", "compunction",
  "concomitant", "conflagration", "consanguineous", "contumelious", "convivial",
  "credulous", "cumbersome", "deleterious", "demagogue", "denouement",
  "deprecate", "desultory", "diaphanous", "didactic", "diffident",
  "disabuse", "discursive", "dissemble", "duplicitous", "ebullient",
  "effervescent", "egregious", "elegiac", "elucidate", "encomium",
  "enervate", "ensconce", "ephemeralize", "equanimity", "equivocate",
  "erudition", "eschew", "esoteric", "evanescent", "exculpate",
  "execrable", "exigent", "expatiate", "expurgate", "fastidious",
  "fatuous", "fecundity", "feckless", "fissiparous", "flagitious",
  "fortuitous", "fractious", "fulminate", "garrulous", "germane",
  "grandiloquent", "halcyon", "hegemony", "iconoclast", "ignominious",
];
